/*! Combined & Optimized Instant Page Preload for Shopify */
let urlToPreload, pageMouseoverTimer, pageLastTouchTimestamp;
const prefetcher = document.createElement("link"),
	isPageSupported = prefetcher.relList && prefetcher.relList.supports && prefetcher.relList.supports("prefetch"),
	isDataSaverEnabled = navigator.connection && (navigator.connection.saveData || navigator.connection.effectiveType.includes('2g')),
	allowPageQueryString = "instantAllowQueryString" in document.body.dataset,
	allowPageExternalLinks = "instantAllowExternalLinks" in document.body.dataset,
	useWhitelist = "instantWhitelist" in document.body.dataset;

if (isPageSupported && !isDataSaverEnabled) {
	prefetcher.rel = "prefetch";
	document.head.appendChild(prefetcher);
	const e = { capture: !0, passive: !0 };
	document.addEventListener("touchstart", touchstartListener, e);
	document.addEventListener("mouseover", mouseoverListener, e);
}

function touchstartListener (e) {
	pageLastTouchTimestamp = performance.now();
	const t = e.target.closest("a");
	isPreloadable(t) && (
		t.addEventListener("touchcancel", touchendAndTouchcancelListener, { passive: !0 }),
		t.addEventListener("touchend", touchendAndTouchcancelListener, { passive: !0 }),
		urlToPreload = t.href,
		preload(t.href)
	);
}

function touchendAndTouchcancelListener () {
	urlToPreload = void 0;
	stopPreloading();
}

function mouseoverListener (e) {
	if (performance.now() - pageLastTouchTimestamp < 1100) return;
	const t = e.target.closest("a");
	isPreloadable(t) && (
		t.addEventListener("mouseout", mouseoutListener, { passive: !0 }),
		urlToPreload = t.href,
		pageMouseoverTimer = setTimeout(() => {
			preload(t.href);
			pageMouseoverTimer = void 0;
		}, 65)
	);
}

function mouseoutListener (e) {
	e.relatedTarget && e.target.closest("a") == e.relatedTarget.closest("a") ||
		(pageMouseoverTimer ? (clearTimeout(pageMouseoverTimer), pageMouseoverTimer = void 0) :
			(urlToPreload = void 0, stopPreloading()));
}

function isPreloadable (e) {
	if (!e || !e.href) return;
	if (urlToPreload == e.href) return;

	if (useWhitelist && !('instant' in e.dataset)) return;
	if ("noInstant" in e.dataset) return;

	const t = new URL(e.href);
	return !(!(allowPageExternalLinks || t.origin == location.origin || "instant" in e.dataset) ||
		!["http:", "https:"].includes(t.protocol) ||
		"http:" == t.protocol && "https:" == location.protocol ||
		!(allowPageQueryString || !t.search || "instant" in e.dataset) ||
		t.hash && t.pathname + t.search == location.pathname + location.search) || void 0;
}

function preload (e) {
	prefetcher.href = e;
}

function stopPreloading () {
	prefetcher.removeAttribute("href");
}